import { useMemo } from 'react'
import moment from 'moment'

import { filterRatePromotions } from 'lib/hotels/bedbankUtils'

export function useBedbankRoomRatePromotions(
  promotions: Array<App.BedbankPromotion> | undefined,
  checkInDate?: string,
  checkOutDate?: string,
  anytimeSearch = false,
) {
  return useMemo(() => filterRatePromotions(promotions ?? [], checkInDate, checkOutDate, anytimeSearch), [promotions, checkInDate, checkOutDate, anytimeSearch])
}

export function useBedbankPromotions(promotions: Array<App.BedbankPromotion>, checkinDate?: moment.Moment, checkoutDate?: moment.Moment) {
  return useMemo(() => {
    return !(checkinDate && checkoutDate) && promotions.length > 0 ? promotions : []
  }, [promotions, checkinDate, checkoutDate])
}

export function useBedbankSearchTilePromotions(promotions: Array<App.BedbankPromotion>, rate?: { id: string }, checkinDate?: string, checkoutDate?: string) {
  return useMemo<Array<App.BedbankPromotion>>(() => {
    if (rate) {
      const ratesPromo = filterRatePromotions(promotions, checkinDate, checkoutDate)
      return ratesPromo[rate.id] ? [ratesPromo[rate.id]] : []
    }

    return promotions
  }, [promotions, rate, checkinDate, checkoutDate])
}
